import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../http";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { toast } from "react-toastify";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function SecondContactus() {
  const [contactData, setContactData] = useState([]);
  const sitedata = useSelector((store) => store.global.loginData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);

  const [contactForm, setContactForm] = useState({
    fullname: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contactForm.fullname) {
      toast.error("Incomplete Form");
      return;
    } else if (!contactForm.email) {
      toast.error("Incomplete Form");
      return;
    } else if (!contactForm.phone) {
      toast.error("Incomplete Form");
      return;
    } else if (
      contactForm?.phone?.length > 14 ||
      contactForm?.phone?.length < 10
    ) {
      toast.error("Invalid Contact Number");
      return;
    } else if (contactForm?.message === "") {
      toast.error("Incomplete Form");
      return;
    }
    try {
      setIsSubmitting(true);
      const response = await SendPostRequest("contact-us-form", contactForm);
      formRef.current.reset();
      if (response.status === "success") {
        setContactForm({
          fullname: "",
          email: "",
          phone: "",
          message: "",
        });
        toast.success(response?.message);
      } else {
        let errorMessage = response?.message || "An error occurred";
        toast.error(`Error: ${errorMessage}`);
        console.error("Error fetching data:", errorMessage);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
      console.error("Error fetching data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      console.log("Enter key pressed");
    }
  };

  // Function to extract src from iframe HTML
  const extractMapSrc = (iframeHtml) => {
    if (!iframeHtml) return null;
    const srcMatch = iframeHtml.match(/src="([^"]*)"/);
    return srcMatch ? srcMatch[1] : null;
  };

  // Function to open Google Map in new tab
  const openGoogleMap = () => {
    if (contactData && contactData.length > 0 && contactData[0].google_map) {
      const mapSrc = extractMapSrc(contactData[0].google_map);
      if (mapSrc) {
        window.open(mapSrc, '_blank');
      } else {
        // Fallback to address search if iframe src not found
        if (sitedata?.site_address) {
          const encodedAddress = encodeURIComponent(sitedata.site_address);
          window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
        }
      }
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    window.scrollTo(0, 0);
    getContactData();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getContactData = async () => {
    const response = await SendPostRequest("content/contactus");
    setContactData(response?.data);
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Contact Us" Image="theme-2-banner-contactus.webp" />

        <div
          id="contact-section"
          className="contact-section pad-bottom-none mt-5"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-5">
                <div
                  className="div-bg-img b-radius-20"
                  style={{
                    backgroundImage: "url(/assets/images/mist/contact-us-form-style-2-cards.webp)",
                    // backgroundImage: "url(/assets/images/mist/contact-style-2-location.webp)",
                    height: isMobile ? "auto" : "290px",
                  }}
                >
                  <div className="f-box c-page text-center typo-white">
                    <div className="feature-icon margin-bottom-10">
                      <i className="ti-location-pin"></i>
                    </div>
                    <div className="feature-content">
                      <div className="feature-title">
                        <h5 className="mb-2">Our Location</h5>
                      </div>
                      <p
                        className="mb-0 contact-us-2-hover"
                        style={{ cursor: 'pointer' }}
                        onClick={openGoogleMap}
                      >
                        {sitedata?.site_address || "--"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-5">
                <div
                  className="div-bg-img b-radius-20"
                  style={{
                    backgroundImage: "url(/assets/images/mist/contact-us-form-style-2-cards.webp)",
                    // backgroundImage: "url(/assets/images/mist/contact-style-2-phone-no.webp)",
                    height: isMobile ? "auto" : "290px",
                  }}
                >
                  <div className="f-box c-page text-center typo-white">
                    <div className="feature-icon margin-bottom-10">
                      <i className="ti-headphone-alt"></i>
                    </div>
                    <div className="feature-content">
                      <div className="feature-title">
                        <h5 className="mb-2">Phone Number</h5>
                      </div>
                      <a
                        className="contact-us-2-hover"
                        href={`tel:${sitedata?.site_contact}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        {sitedata?.site_contact || "--"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-5">
                <div
                  className="div-bg-img b-radius-20"
                  style={{
                    backgroundImage: "url(/assets/images/mist/contact-us-form-style-2-cards.webp)",
                    // backgroundImage: "url(/assets/images/mist/contact-style-2-email-address.webp)",
                    height: isMobile ? "auto" : "290px",
                  }}
                >
                  <div className="f-box c-page text-center typo-white">
                    <div className="feature-icon margin-bottom-10">
                      <i className="ti-email"></i>
                    </div>
                    <div className="feature-content">
                      <div className="feature-title">
                        <h5 className="mb-2">Email Address</h5>
                      </div>
                      <a
                        className="contact-us-2-hover"
                        href={`mailto:${sitedata?.business_email || sitedata?.site_email}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        {sitedata?.business_email || sitedata?.site_email || "--"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="section-contact" className="section-contact mb-5">
          <div className="container">
            <div className="row ">
              <p className="form-message" style={{ display: "none" }}></p>
              <div className="contact-form" data-animation="fadeInLeft">
                <form
                  ref={formRef}
                  onSubmit={handleSubmit}
                  onKeyDown={handleKeyDown}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-text form-group mb-3">
                        <input
                          type="text"
                          className="input-name form-control"
                          placeholder="Full Name"
                          name="fullname"
                          value={contactForm?.fullname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-email form-group mb-3">
                        <input
                          type="email"
                          className="input-email form-control"
                          placeholder="Email"
                          name="email"
                          value={contactForm?.email}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="input-email form-group mb-3">
                        <input
                          type="text"
                          className="input-phone form-control"
                          placeholder="Phone"
                          name="phone"
                          value={contactForm?.phone}
                          onChange={handleInputChange}
                          maxLength={11}
                          minLength={10}
                        />
                      </div>
                      <div className="textarea-message form-group mb-3">
                        <textarea
                          className="textarea-message form-control"
                          placeholder="Message"
                          rows="4"
                          name="message"
                          value={contactForm?.message}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                      <button
                        className="btn btn-default btn-block"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending..." : "Send Now"}{" "}
                        <i className="icon-paper-plane ms-1"></i>
                      </button>
                    </div>
                    <div className="col-md-6 pad-top-md-30">
                      {/* <div className="cs_map contact-map">
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              contactData &&
                              contactData.length > 0 &&
                              contactData[0].google_map
                                ? contactData[0].google_map
                                : "",
                          }}
                        />
                      </div> */}
                      {contactData &&
                        contactData.length > 0 &&
                        contactData[0].google_map &&
                        contactData[0].google_map.includes("google.com/maps") ? (
                        <div className="cs_map contact-map" style={{ width: "100%", height: "400px" }}>
                          <div
                            dangerouslySetInnerHTML={{ __html: contactData[0].google_map }}
                          />
                        </div>
                      ) : null}

                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default SecondContactus;